import React from 'react';
import { SessionPlayer } from 'js/assessment';

const SessionPlayerPage = props => {
    return <SessionPlayer {...props} />;
};

export default SessionPlayerPage;
